(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.playlist.factory.api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../api/async')
    ])
    .factory('PlaylistContent', playlistContent)

  playlistContent.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function playlistContent (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/ccmt/v2/playlist-content')

    return {
      get: API.get
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/playlist/factory/playlist-api.js